import { PayoutResult } from "types/enums.ts";

export const allPayoutResultValues = [PayoutResult.Approved, PayoutResult.Pending, PayoutResult.Rejected];
